import { apis } from '../apiBase/apiBase';
const aiCreditUsageHistoryApis = apis.injectEndpoints({
    endpoints: (builder) => ({
        getAiCreditUsageHistories: builder.query({
            query: (params) => ({
                url: `ai-credit-usage-histories`,
                method: 'GET',
                params,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetAiCreditUsageHistoriesQuery, useLazyGetAiCreditUsageHistoriesQuery, } = aiCreditUsageHistoryApis;
